export function log(message: any) {
  if (window.localStorage.getItem("dev")) {
    console.log(message);
  }
}
